<!--拷贝复制的login-->
<template>
  <div class="login-container">
    <el-row>
      <el-col :lg="1" :md="1" :sm="24" :xl="14" :xs="24">
        <div style="color: transparent">占位符</div>
      </el-col>
      <el-col :lg="22" :md="22" :sm="24" :xl="22" :xs="24">
        <div class="login-div">
          <div class="login-div-left">
            <el-image
              style="width: 350px; height: 400px"
              class="hidden-md-and-down"
              :src="url"
              fit="fit" />
          </div>
          <div class="login-div-right">
            <div class="title">hello !</div>
            <div class="title-tips">欢迎免费试用BDA小助手</div>
            <el-form
              ref="form"
              class="login-form"
              label-position="left"
              :model="form"
              :rules="rules"
            >
              <el-form-item prop="username" style="margin-top: 40px;">
                <el-input
                  v-model.trim="form.username"
                  placeholder="请输入手机号码登录/注册"
                  prefix-icon="el-icon-mobile-phone"
                  maxlength="11"
                  tabindex="1"
                  type="text"
                  clearable
                >
                </el-input>
                <!--                <el-alert title="*提示：近期短信平台在开展安全审核，建议使用联通、电信号码，移动仍在审核中暂无法正常发送验证码，如确实需使用移动，请联系QQ客服手动发验证码！" type="warning" />-->
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  :key="passwordType"
                  v-model.trim="form.password"
                  placeholder="请输入短信验证码"
                  prefix-icon="el-icon-lock"
                  maxlength="4"
                  tabindex="2"
                >
                  <template v-if="passwordType === 'password'" #suffix>
                    <div style="margin-right: 25px;margin-top: 5px">
                      <el-button type="text" @click="handleGetCode">{{ codeMsg }}</el-button>
                    </div>
                  </template>
                  <template v-else #suffix>
                    <div style="margin-right: 50px;margin-top: 8px;color: #1E90FF">
                      {{ form.second }} S
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-button
                class="login-btn"
                :loading="loading"
                type="primary"
                @click="handleLogin"
              >
                申请试用1个月
              </el-button>
<!--              <div style="margin-top: 20px">-->
<!--                <el-button type="text" @click="handleRedirect">没有账号？点击注册</el-button>-->
<!--              </div>-->
              <!--              <router-link to="/register">-->
              <!--                <div style="margin-top: 20px">没有账号？点击购买注册</div>-->
              <!--              </router-link>-->
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col :lg="1" :md="1" :sm="24" :xl="1" :xs="24">
        <div style="color: transparent">占位符</div>
      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center>
      <span>
        <el-result :icon="iconStatus" :title="iconTitle" :sub-title="iconTips">
        </el-result>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex'
// import { translateTitle } from '@/utils/i18n'
// import { isPassword } from '@/utils/validate'
// 加载VabIcon
// import VabIcon from 'vab-icons'
import img1 from '@/assets/images/back/left_img-fba58be9.png'
import { getCodeInfo, getSmsCode } from '@/api/login'
import { getTrial } from '@/api/trial'
import { urlParam } from '@/utils/url'

export default {
  name: 'Login',
  components: {
    // VabIcon
  },
  // directives: {
  //   focus: {
  //     inserted(el) {
  //       el.querySelector('input').focus()
  //     }
  //   }
  // },
  // beforeRouteLeave(to, from, next) {
  //   clearInterval(this.timer)
  //   next()
  // },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      // if (!isPassword(value)) {
      //   callback(new Error('验证码不能少于4位'))
      // } else {
      //   callback()
      // }
      if (value === '') {
        callback(new Error('验证码不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        username: '',
        password: '',
        verificationCode: '',
        second: 1
      },
      rules: {
        username: [
          {
            required: true,
            trigger: 'blur',
            validator: validateUsername
          }
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePassword
          }
        ]
        /* verificationCode: [
          {
            required: true,
            trigger: 'blur',
            message: '验证码不能空',
          },
        ], */
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      timer: 0,
      codeUrl: 'https://www.oschina.net/action/user/captcha',
      previewText: '',
      url: img1,
      centerDialogVisible: false,
      iconStatus: 'success',
      iconTitle: '登录成功',
      iconTips: '请关闭所有Word，并重新打开。可关闭本网页。',
      codeMsg: '获取验证码',
      param: {},
      unid: ''
    }
  },
  // watch: {
  //   $route: {
  //     handler(route) {
  //       this.redirect = (route.query && route.query.redirect) || '/'
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    // 读取本地
    var data2 = localStorage.getItem('booleardaPhone')
    this.form.username = data2
    this.form.password = ''
    // this.previewText = '可不填'
    // 为了演示效果，会在官网演示页自动登录到首页，正式开发可删除
    // if (
    //   document.domain === 'vue-admin-beautiful.com' ||
    //   document.domain === 'chu1204505056.gitee.io'
    // ) {
    //   this.previewText = '（演示地址验证码可不填）'
    //   this.timer = setTimeout(() => {
    //     this.handleLogin()
    //   }, 5000)
    // }
    // 获取链接的参数
    this.param = urlParam
    // this.codeMsg = this.param.id
    // console.log('获取的参数为')
    // console.log(this.codeMsg)
  },
  methods: {
    handlePassword() {
      this.passwordType === 'password'
        ? (this.passwordType = '')
        : (this.passwordType = 'password')
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleRoute() {
      return this.redirect === '/404' || this.redirect === '/403'
        ? '/'
        : this.redirect
    },
    handleRedirect() {
      // window.location.href = `http://baidu.com?id=${this.param.id}&oname=${this.param.oname}&timestamp=${this.param.timestamp}`
      this.$router.push({
        path: '/pay',
        query: {
          id: this.param.id,
          oname: this.param.oname,
          code: this.param.code,
          timestamp: this.param.id
        }})
    },
    async handleSendCode() {
      // 定义参数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.param.code,
        'phone': this.form.username,
        'name': this.param.oname,
        'timestamp': timestamp
      }
      getSmsCode(params).then((res) => {
        console.log('获得返回数据1111')
        console.log(res)
        console.log(res['code'])
        if (res['code'] === 200) {
          this.$message({
            message: '短信验证码已发送',
            type: 'success'
          })
          this.unid = res['data']['unid']
        } else {
          const errorMsg = `发送失败：${res['msg']}`
          this.$message({
            message: errorMsg,
            type: 'error'
          })
        }
      })
    },
    handleGetCode() {
      // eslint-disable-next-line eqeqeq
      if (this.form.username == '' || this.form.username === undefined || this.form.username.length !== 11) {
        this.$message({
          message: '手机号不能为空，且为11位长度',
          type: 'error'
        })
        return
      }
      this.handleSendCode().then(result => {
        // this.timer = setInterval(() => {
        //   console.log(result)
        // }, 5000)
        console.log(result)
      })
      this.passwordType = ''
      this.form.second = 60
      this.timer = setInterval(() => {
        this.form.second--
        if (this.form.second === 0) {
          this.form.second = 0
          this.passwordType = 'password'
          this.codeMsg = '重新获取'
        }
      }, 1000)
    },
    handleGetTrial() {
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.param.code,
        'name': this.param.oname,
        'mac': this.param.ma,
        'phone': this.form.username,
        'timestamp': timestamp
      }
      getTrial(params).then((res) => {
        console.log('获得返回数据33')
        console.log(res)
        if (res['code'] === 200) {
          console.log('申请试用成功')
          var type = 'Word'
          switch (this.param.oname) {
            case 'VST001':
              type = '所有Excel'
              break
            case 'VST002':
              type = '所有Word'
              break
            case 'PDF001':
              type = '所有PDF'
              break
            default:
              type = '软件'
              break
          }
          const successMsg = `请关闭${type}，并重新打开可使用软件。`
          this.centerDialogVisible = true
          this.iconStatus = 'success'
          this.iconTitle = '申请成功'
          this.iconTips = successMsg
          // 保存本地
          const str = this.form.username
          localStorage.setItem('booleardaPhone', str)
        } else {
          const errorMsg2 = `${res['msg']}`
          this.centerDialogVisible = true
          this.iconStatus = 'error'
          this.iconTitle = '申请失败'
          this.iconTips = errorMsg2
        }
      })
    },
    handleLogin() {
      // 校验数据完整
      console.log(this.param.code)
      if (this.param.code === '' || this.param.code === undefined) {
        // 用来判断id是否在
        // this.$message({
        //   message: '页面已失效，请在软件中重新点击注册',
        //   type: 'error'
        // })
        this.$alert('页面已失效，请在软件中重新申请试用进入', '', {
          confirmButtonText: '确定',
          type: 'error'
        })
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.form.username == '' || this.form.username === undefined || this.form.username.length !== 11) {
        this.$message({
          message: '手机号不能为空，且为11位长度',
          type: 'error'
        })
        return
      }
      if (this.form.password === '' || this.form.password === undefined || this.form.password.length !== 4) {
        this.$message({
          message: '验证码不能为空，且为4位长度',
          type: 'error'
        })
        return
      }
      // 验证码是否有效
      var paraSms = {
        'id': this.unid,
        'phone': this.form.username,
        'code': this.form.password
      }
      getCodeInfo(paraSms).then((res) => {
        console.log('获得返回数据22')
        console.log(res)
        // console.log(res['code'])
        if (res['code'] === 200) {
          console.log('验证码有效')
          // 开始申请试用
          this.handleGetTrial()
        } else {
          const errorMsg = `${res['msg']}`
          this.$message({
            message: errorMsg,
            type: 'error'
          })
        }
      })

      // this.$refs.form.validate(async(valid) => {
      //   if (valid) {
      //     try {
      //       this.loading = true
      //       await this.login(this.form).catch(() => {})
      //       await this.$router.push(this.handleRoute())
      //     } finally {
      //       this.loading = false
      //     }
      //   }
      // })
      //
    },
    changeCode() {
      this.codeUrl = `https://www.oschina.net/action/user/captcha?timestamp=${new Date().getTime()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  margin: 0;
  background: url('~@/assets/images/back/back_blue_01.jpg') center center fixed
  no-repeat;
  background-size: cover;
  overflow: hidden;
}
.text-a {
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  color: #bbbbbb;
  font-size: small;
}

.login-image{
  width: 100%;
  height: 270px;
  //background: url('~@/assets/images/back/left_img-fba58be9.png') center center fixed
}
.login-div{
  overflow: hidden;
  background: white;
  background-size: 100% 100%;
  border-radius:12px;
  margin: calc((100vh - 475px) / 2) 15vw 15vw;
  padding: 4.5vh;
}
.login-div-left{
  float: left;
  width: 50%;
  vertical-align: center;
}
.login-div-right{
  float: right;
  width: 50%;
  .title {
    font-size: 54px;
    font-weight: 500;
    color: #1f1f1f;
  }
  .title-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: #605f5f;
  }
}

.login-form {
  position: relative;
  max-width: 100%;
  width: 100%;
  //padding: 4.5vh;
  //margin: calc((100vh - 475px) / 2) 15vw 15vw;
  //overflow: hidden;
  //background: url('~@/assets/login_images/login_form.png');
  //background: white;
  //background-size: 100% 100%;
  //border-radius:15px;

  .login-btn {
    display: inherit;
    width: 220px;
    height: 50px;
    margin-top: 10px;
    border: 0;

    &:hover {
      opacity: 0.9;
    }

    .forget-passwordword {
      width: 100%;
      margin-top: 40px;
      text-align: left;

      .forget-password {
        width: 129px;
        height: 19px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(92, 102, 240, 1);
      }
    }
  }

  .tips {
    margin-bottom: 10px;
    font-size: 14px;
    color:#fff;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      margin: 0 auto 40px auto;
      font-size: 34px;
      font-weight: bold;
      color: #1890ff;
      text-align: center;
    }
  }
  i {
    position: absolute;
    top: 8px;
    left: 5px;
    z-index: 1999;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  .show-password {
    position: absolute;
    right: 25px;
    left: -35px;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  ::v-deep {
    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__content {
        min-height: 32px;
        line-height: 32px;
      }

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: 12px;
        line-height: 18px;
        color: #ff4d4f;
      }
    }

    .el-input {
      box-sizing: border-box;

      input {
        height: 48px;
        padding-left: 35px;
        font-size: 14px;
        line-height: 58px;
        background: #faf9fc;
        border: 1px;
      }
    }

    .code {
      position: absolute;
      top: 4px;
      right: 4px;
      cursor: pointer;
      border-radius: 2.5px;
    }
  }
}
</style>
